import React, { useState, useEffect } from 'react';
import SideBar from './Components/SideBar';
import CustomButton from './Components/Buttons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DatabaseUtil from './Util/DatabaseUtil';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale } from 'chart.js';

// Register ChartJS components
ChartJS.register(ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale);

function DashSurveySummary() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedRole, setSelectedRole] = useState('Student');
    const [questions, setQuestions] = useState([]);
    const [analysis, setAnalysis] = useState({});

    useEffect(() => {
        loadSurveyData();
    }, [selectedRole, i18n.language]);

    //Method to create the charts
    const generateChartData = (responses) => {
        if (!responses || responses.length === 0) return null;
        
        const labels = responses.map(([answer]) => answer);
        const data = responses.map(([_, count]) => count);
        const colors = [
            '#C83C58', '#346eeb', '#FFB41F', '#C3DD86', 
            '#9966FF', '#FF9F40', '#FF6384', '#36A2EB'
        ]; //Colors for the pie chart

        return {
            labels,
            datasets: [{
                data,
                backgroundColor: colors.slice(0, data.length),
                borderWidth: 5,
                //borderColor: 'var(--primary-color)', 
            }]
        };
    };


    const loadSurveyData = async () => {
        try {
            setLoading(true);
            // Load questions for the selected role
            const surveyQuestions = await DatabaseUtil.getSurveyQuestions(selectedRole, i18n.language);
            setQuestions(surveyQuestions);

            // Load and analyze responses
            const responses = await DatabaseUtil.getSurveyResponses(selectedRole);
            const analysisResults = DatabaseUtil.analyzeSurveyResponses(responses, surveyQuestions);
            setAnalysis(analysisResults);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    const roles = ['Student', 'Caregiver', 'Teacher', 'Classmate'];
    const rolesLower = ['student', 'caregiver', 'teacher', 'classmate'];

    return (
        <>
            <SideBar />
            <div style={{ padding: '20px', fontFamily: 'KomikaAxis', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '60%' }}>
                    <h2 style={{ fontFamily: 'KomikaAxis', color: 'var(--primary-color)'}}>{t('Survey')}</h2>
                
                    <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
                    {/*Loop to create role buttons*/}
                    {roles.map((role, index) => (
    <CustomButton
        key={role}
        label={t(rolesLower[index])}
        onClick={() => setSelectedRole(role)}
        type={selectedRole === role ? "secondary" : "primary"}
        style={{
            padding: '10px 20px',
            fontSize: '16px'
        }}
    />
))}

                </div>

                {loading ? (
                    <p>Loading Survey...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}>{error}</p>
                ) : (
                    <div className="survey-results">
                        {questions.map((question, index) => {
                            const responses = analysis[question.Question] || [];
                            const chartData = generateChartData(responses);
                            
                            return (
                                <div key={index} style={{ 
                                    marginBottom: '20px',
                                    padding: '20px',
                                    backgroundColor: 'var(--primary-color)', 
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginRight: '20px',
                                     maxWidth: '1500px',
                                     color: 'var(--primary-white-color)'
                                }}>
                                    <h3 style={{ marginBottom: '15px' }}>{question.Question}</h3>
                                    
                                    {responses.length > 0 ? (
                                        <div style={{ display: 'flex', gap: '20px', }}>
                                            <div style={{ width: '300px', height: '300px' }}>
                                                <Pie 
                                                    data={chartData}
                                                    options={{
                                                        plugins: {
                                                            legend: {
                                                                display: false
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <h4 >Responses:</h4>
                                                <ol style={{ paddingLeft: '40px' }}>
                                                    {responses.map(([answer, count], i) => (
                                                        <li key={i} style={{ 
                                                            marginBottom: '8px',
                                                            fontSize: '12px',
                                                            textAlign: 'left'
                                                        }}>
                                                            {answer}: <strong>{count}</strong>
                                                        </li>
                                                    ))}
                                                </ol>
                                            </div>
                                        </div>
                                    ) : (
                                        <p style={{ color: '#6c757d' }}>No responses</p>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
                </div>
            </div>
        </>
    );
}

export default DashSurveySummary;